import Vue from 'vue'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import moment from 'moment'
import Buefy from 'buefy'

import App from './App.vue'
import store from './store'
import filters from './services/filters'

// CSS
import './style/main.css'
import 'bootstrap/dist/css/bootstrap-grid.min.css'
import 'buefy/dist/buefy.css'

// Buefy
import { Datepicker } from 'buefy/dist/components/datepicker'
import { Timepicker } from 'buefy/dist/components/timepicker'
import { Field } from 'buefy/dist/components/field'
import { Select } from 'buefy/dist/components/select'
import { Input } from 'buefy/dist/components/input'

Vue.component('b-datepicker', Datepicker)
Vue.component('b-timepicker', Timepicker)
Vue.component('b-field', Field)
Vue.component('b-select', Select)
Vue.component('b-input', Input)

require('moment/locale/de')

moment.locale(window.navigator.language)

Vue.use(VeeValidate, { locale: 'de', classes: true })

const server = 'https://vc-rent.velocate.com'
// const server = 'http://localhost:3002'
const path = '/rental-system/api'
axios.defaults.baseURL = server + path

function VelocateRentalSystem(embedToken, options = {}) {
	store.commit('SET_EMBED_TOKEN', embedToken)

	if (options.includeCSS) {
		// Add stylesheet to head when true
		const link = document.createElement('link')
		link.type = 'text/css'
		link.rel = 'stylesheet'
		link.href = 'https://files.velocate.com/rental-system/plugin/app.css'
		document.body.appendChild(link)
	}

	return new Vue({
		name: 'VelocateRentalSystem',
		el: '#velocate-rental-system-app',
		store,
		render: h => h(App),
		parent: window.$nuxt
	})
}

window.VelocateRentalSystem = VelocateRentalSystem

if(process.env.NODE_ENV==="development"){
	const RentalSystem = new VelocateRentalSystem('ce7ddcf6e10c6a4eb7b7a062122559')
}
